import { useCallback } from "react";

export const useAnalytics = () => {
  const trackClick = useCallback(async (type, id) => {
    if (type) {
      const dataLayer = {
        event: "select_content",
        ecommerce: {
          content_type: type,
          content_id: id,
        },
      };

      pushGA4Event(dataLayer);
    }
  }, []);

  return {
    trackClick,
  };
};

function pushGA4Event(payload) {
  if (
    !payload ||
    "undefined" === typeof window ||
    "undefined" === typeof window.dataLayer
  ) {
    return;
  }

  // Clear previous ecommerce data if needed.
  if (payload.ecommerce) {
    window.dataLayer.push({ ecommerce: null });
  }

  window.dataLayer.push(payload);
}
